<form class="ir-modal th-modal">
  <div class="ir-modal--title">
    <div class="ir-line--right">
      <div class="ir-btn th-btn-modal" (click)="selfModal.close()"><i class="material-icons">close</i></div>
    </div>
    <div class="ir-line">
      <div class="ir-line-content">
        <span>{{ 'common.add' | translate }}:{{ 'plugins.marketing.presentations' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="ir-modal--body has-footer">
    <div class="ir-content--modal th-content">
      <app-annotation-layer
        [model]="inputObject"
        [undoTrigger]="undoTrigger"
        [saveTrigger]="saveTrigger"
        (getOutput)="getOutput($event)"
        *ngIf="inputObject"
      ></app-annotation-layer>
    </div>
  </div>
  <div class="ir-modal--footer ir-position--b th-modal--footer">
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="selfModal.close()">
          <span>{{ 'common.cancel' | translate }}</span>
        </div>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <button class="ir-btn ir-btn--big ir-btn--block ir-txt--right" type="submit" (click)="apply()">
          <span>{{ 'common.save-changes' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</form>
